import { myPalette } from './myPalette'

export const cardHoverAnimation = `
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${myPalette.dark['100']};
    transform: translateY(-5px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`
